import { HTTP_STATUS_CODE } from "@constants/api.response.code";

const DEFAULT_RETRY_AFTER_SECONDS = 60;

const getRetryBufferSeconds = retryAfterSeconds => {
  if (retryAfterSeconds < 15) return 15;
  if (retryAfterSeconds < 30) return 10;
  if (retryAfterSeconds < 60) return 5;
  return 0;
};

// Supports both Fetch Headers and Axios header objects.
const getHeaderValue = (headers, name) => {
  if (typeof headers?.get === "function") {
    return headers.get(name);
  }
  return headers?.[name.toLowerCase()] ?? headers?.[name];
};

// Converts the server retry delay into an expiry timestamp.
export const getRateLimitExpiry = (headers, data, now = Date.now()) => {
  const retryAfter = Number(getHeaderValue(headers, "Retry-After") ?? data?.retryAfterSeconds);
  const retryAfterSeconds = Number.isFinite(retryAfter) && retryAfter > 0 ? retryAfter : DEFAULT_RETRY_AFTER_SECONDS;
  const cooldownSeconds = retryAfterSeconds + getRetryBufferSeconds(retryAfterSeconds);
  return now + cooldownSeconds * 1000;
};

// Creates an Axios-shaped error for requests blocked during cooldown.
export const createRateLimitError = () => ({
  code: "RATE_LIMIT_ERROR",
  name: "RateLimitError",
  message: "Too many requests. Please retry later.",
  isRateLimitGuard: true,
  response: {
    status: HTTP_STATUS_CODE.TOO_MANY_REQUESTS,
    data: {
      errorCode: "RATE_LIMIT_EXCEEDED",
      errorMessage: "Too many requests. Please retry later.",
    },
  },
});

// Waits until cooldown expiry (or returns immediately if already expired).
export const waitForRateLimitCooldown = async expiry => {
  const waitMs = Number(expiry) - Date.now();
  if (!Number.isFinite(waitMs) || waitMs <= 0) return;
  await new Promise(resolve => {
    setTimeout(resolve, waitMs);
  });
};
